import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import LogHistoryPannel from './index'

const defaultOption = {
  busiObjId:'',
  busiObjCode:'',
  busiObjName:'null',
  currentTime:'',
  record:{},
}
export default function createLogPannel(option=defaultOption){
  if(typeof document == 'undefined'){return}
  let div = document.createElement('div')
  document.body.appendChild(div)
  function destory(){
    ReactDOM.unmountComponentAtNode(div);//也可通过childNodes来实现纯js卸载
    document.body.removeChild(div)
  }
  function render(){
    ReactDOM.render(<LogHistoryPannel showHistory={true} closePannel={destory} {...option}/>,div);
  }
  render()
}


// WEBPACK FOOTER //
// ./src/components/zHistoryLog/createApi.js